/*
 * @Description: 透传接口axios封装
 * @Author: luozhao
 * @Date: 2020-08-20 15:45:35
 */
import axios from 'axios';
import { CROS_API } from '../config/app.config';
// import { addPending, removePending } from './cancelRequest';
import SecurityService from './security.service';
let securityServiceInstance = new SecurityService();
/* 实例化axios */
let AxiosInstance = axios.create({});

/* 实例对象默认配置 */
AxiosInstance.defaults.baseURL = CROS_API; // 基础路径
AxiosInstance.defaults.responseType = 'json'; // 返回数据类型json
AxiosInstance.defaults.timeout = 20000; // 超时时间

/**
 * 请求拦截器
 */
AxiosInstance.interceptors.request.use(
  async config => {
    let tempData = config.data;
    // console.log('crosRequestHandler---config:',config);
    tempData.loginPlatformCode = tempData.loginPlatformCode || sessionStorage.getItem('loginPlatformCode');
    tempData.platformCode = tempData.platformCode || sessionStorage.getItem('platformCode');
    tempData.timestamp = new Date().getTime()
    // 课后服务appId
    tempData.appId = '5txk2cf684cj6x7b28r6darkt38tr4jw';
    // 组装cancel axiso 存储参数
    // const cancleOptionData = Object.assign({}, tempData);
    // delete cancleOptionData.timestamp;
    // const cancelOptions = {
    //   method: config.method,
    //   url: config.url,
    //   params: config.params,
    //   data: cancleOptionData
    // };
    // // 在请求开始前，对之前的请求做检查取消操作
    // removePending(cancelOptions);
    // // 将当前请求添加到 pending 中
    // addPending(AxiosInstance, cancelOptions, config);
    const securityParams = await securityServiceInstance.getParams();
    // if (sessionStorage.getItem('needConsole') === '1') {
    //   console.log(tempData);
    //   console.log(JSON.stringify(tempData));
    // }
    config.data = {
      encrypt: await securityServiceInstance.AESEncrypt(tempData)
    };
    config.headers.s = securityParams.sessionId;
    config.headers.loginPlatformCode = sessionStorage.getItem('loginPlatformCode') || '420100';;
    config.headers.platformCode = sessionStorage.getItem('platformCode') || '420100'
    // 透传加密 新增安全加固 query带 authPlatformCode 参数时
    if (sessionStorage.getItem('authPlatformCode')) {
      config.headers['Ty-Auth-Platform'] = sessionStorage.getItem(
        'authPlatformCode'
      );
    }
    // if (sessionStorage.getItem('needConsole') === '1') {
    //   console.log(JSON.stringify(config));
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截器
 */
AxiosInstance.interceptors.response.use(
  async response => {
    // 组装 移除请求组成参数参数，和request拦截器中 cancelOptions 保持相同
    // const config = response.config;
    // const configData = await securityServiceInstance.AESDecrypt(JSON.parse(config.data).encrypt);
    // const optionData = Object.assign({}, configData);
    // delete optionData.timestamp;
    // // 在请求结束后，移除本次请求
    // removePending({
    //   method: config.method,
    //   url: config.url,
    //   params: config.params,
    //   data: optionData
    // });

    const formatData = await securityServiceInstance.AESDecrypt(response.data.data);
    // 兼容地方平台http协议无法访问的问题
    let platformCode, ticket, domain, openGatewayUrl, uc7manageUrl
    platformCode = sessionStorage.getItem('platformCode')
    ticket = sessionStorage.getItem('ticket')
    domain = sessionStorage.getItem('domain')
    openGatewayUrl = formatData.openGatewayUrl
    uc7manageUrl = formatData.uc7manageUrl
    // console.log('打印参数拦截的参数**',platformCode,ticket,domain,openGatewayUrl,uc7manageUrl);
    if (process.env.VUE_APP_MODE !== 'test' && formatData.openGatewayUrl && formatData.openGatewayUrl.substring(0, 5) != 'https' && platformCode!='370786') {
      window.location.href = `http://assfe.huijiaoyun.com/?ticket=${ticket}&platformCode=${platformCode}&domain=${domain}&openGatewayUrl=${openGatewayUrl}&uc7manageUrl=${uc7manageUrl}`
      // window.location.href = `https://assfe.huijiaoyun.com/?ticket=${ticket}&platformCode=${platformCode}`
    } 
    // console.log('透传返回-->', formatData);
    return formatData;
  },
  err => {
    if (axios.isCancel(err)) {
      console.log('repeated request: ' + err);
    }
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误';
          break;
        case 401:
          err.message = '未授权，请登录';
          break;
        case 403:
          err.message = '拒绝访问';
          break;
        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`;
          break;
        case 408:
          err.message = '请求超时';
          break;
        case 500:
          err.message = '服务器内部错误';
          break;
        case 501:
          err.message = '服务未实现';
          break;
        case 502:
          err.message = '网关错误';
          break;
        case 503:
          err.message = '服务不可用';
          break;
        case 504:
          err.message = '网关超时';
          break;
        case 505:
          err.message = 'HTTP版本不受支持';
          break;
        default:
          err.message = '服务出错';
          break;
      }
    }
    return Promise.reject(err);
  }
);

export default AxiosInstance;
